import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2),
    paddingBottom: theme.spacing(4),
  },

  info: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
  },

  button: {
    minWidth: 124,

    [theme.breakpoints.down('md')]: {
      minWidth: 'auto',
    },
  },
}));
